import React from 'react'
import "./Footer.css"
export default function Footer() {
  return (
    <div className="footer">
         <div>
            
            <ul>
               <li><h2>Learn more</h2></li>
               <li>Individuals</li>
               <li>Photographers</li>
               <li>Marketing</li>
               <li>Developers</li>
               <li>Media</li>
               <li>Car Dealerships</li>
               <li>Enterprise</li>
               <li>Pricing</li>
            </ul>
         </div>

         <div>
            <ul>
               <li><h2>Tools & API</h2></li>
               <li>API Documentation</li>
               <li>Integrations, tools & apps</li>
               <li>Photoshop Extension</li>
               <li>Windows / Mac / Linux</li>
               <li>Android App</li>
               <li>Design Templates</li>
            </ul>
         </div>

         <div>
           
            <ul>
               <li><h2>Support</h2></li>
               <li>Help & FAQs</li>
               <li>Contact us</li>
               <li>Refunds</li>
               <li>Platform Status</li>
            </ul>
         </div>

         <div>
            
            <ul>
               <li><h2>Company</h2></li>
               <li>Blog</li>
               <li>Affiliate Program</li>
               <li>Create automatic designs</li>
               <li>Video Background Removal</li>
               <li>Media</li>
               <li>Careers</li>
               <li>About us</li>
               <li>Press</li>
            </ul>
         </div>
    </div>
  )
}
